import { normalizeVoiceText, removeVoicePhrase } from './matchVoiceSearchCity';

const OPEN_24H_PHRASES = [
  "that's open 24 hours",
  'that is open 24 hours',
  'open 24 hours a day',
  'open twenty four hours',
  'open 24 hours',
  'open 24 hrs',
  'open 24h',
  'open 24/7',
  'open all day',
  'around the clock',
  'round the clock',
  'twenty four hours',
  'שפתוח עשרים וארבע שעות',
  'פתוח עשרים וארבע שעות',
  'שפתוח 24 שעות',
  'פתוח 24 שעות',
  'פתוח 24 שעה',
  'פתוח כל היום',
  'פתוח 24/7',
  '24 שעות ביממה',
  'עשרים וארבע שעות',
  '24 hours a day',
  '24/7',
  '24 7',
  '24h',
  '24 שעות',
  '24 hours',
  '24 hrs',
].sort((a, b) => b.length - a.length);

export type AssistantOpen24h = {
  matched: boolean;
  remainder: string;
};

/** Spoken “open 24 hours” / פתוח 24 שעות — not leftover venue keywords. */
export function parseAssistantOpen24h(text: string): AssistantOpen24h {
  let remainder = normalizeVoiceText(text);
  if (!remainder) {
    return { matched: false, remainder: '' };
  }
  let matched = false;
  for (const phrase of OPEN_24H_PHRASES) {
    const needle = normalizeVoiceText(phrase);
    if (!needle || !remainder.includes(needle)) {
      continue;
    }
    remainder = removeVoicePhrase(remainder, needle);
    matched = true;
  }
  return { matched, remainder };
}
